import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const FeatureCtx = createContext({ features: {}, loading: true });

export function FeatureProvider({ children }) {
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    try {
      const { data } = await api.get("/features");
      // data is either map or array (admin)
      if (Array.isArray(data)) {
        const map = {};
        data.forEach((f) => { map[f.key] = f.enabled; });
        setFeatures(map);
      } else {
        setFeatures(data);
      }
    } catch (_) {
      setFeatures({});
    } finally { setLoading(false); }
  };

  useEffect(() => { reload(); }, []);

  return (
    <FeatureCtx.Provider value={{ features, loading, reload, isOn: (k) => !!features[k] }}>
      {children}
    </FeatureCtx.Provider>
  );
}

export const useFeatures = () => useContext(FeatureCtx);
